import {
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  VOID3gxj6tk5isa35 as VOID,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Enum3alwj03lh1n41 as Enum,
  toString30pk9tzaqopn as toString,
  Exceptiondt2hlxn7j7vw as Exception,
  equals2au1ep9vhcato as equals,
  StringBuildermazzzhj6kkai as StringBuilder,
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  protoOf180f3jzyo7rfj as protoOf,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class KLogger {}
function debug(message) {
  var tmp = Level_DEBUG_getInstance();
  return this.x8l(tmp, VOID, KLogger$debug$lambda(message));
}
function warn(message) {
  var tmp = Level_WARN_getInstance();
  return this.x8l(tmp, VOID, KLogger$warn$lambda(message));
}
function error(message) {
  var tmp = Level_ERROR_getInstance();
  return this.x8l(tmp, VOID, KLogger$error$lambda(message));
}
function error_0(throwable, message) {
  var tmp = Level_ERROR_getInstance();
  return this.x8l(tmp, VOID, KLogger$error$lambda_0(message, throwable));
}
function at$default(level, marker, block, $super) {
  marker = marker === VOID ? null : marker;
  var tmp;
  if ($super === VOID) {
    this.b8m(level, marker, block);
    tmp = Unit_instance;
  } else {
    tmp = $super.b8m.call(this, level, marker, block);
  }
  return tmp;
}
class KLoggingEventBuilder {
  constructor() {
    this.r8l_1 = null;
    this.s8l_1 = null;
    this.t8l_1 = null;
    this.u8l_1 = null;
    this.v8l_1 = null;
  }
}
class KotlinLogging {
  c8m(name) {
    return KLoggerFactory_instance.c8m(name);
  }
}
class Level extends Enum {
  constructor(name, ordinal, levelInt, levelStr) {
    super(name, ordinal);
    this.f8m_1 = levelInt;
    this.g8m_1 = levelStr;
  }
  toString() {
    return this.g8m_1;
  }
}
class DefaultErrorMessageProducer {
  h8m(e) {
    return 'Log message invocation failed: ' + e.toString();
  }
}
class FormattingAppender {
  j8m(loggingEvent) {
    // Inline function 'kotlin.let' call
    var it = KotlinLoggingConfiguration_getInstance().l8m_1.n8m(loggingEvent);
    this.i8m(loggingEvent, it);
  }
}
class DefaultMessageFormatter {
  constructor(includePrefix) {
    includePrefix = includePrefix === VOID ? true : includePrefix;
    this.o8m_1 = includePrefix;
  }
  n8m(loggingEvent) {
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    this_0.m1(prefix(this, loggingEvent.p8m_1, loggingEvent.r8m_1));
    var tmp0_safe_receiver = loggingEvent.q8m_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v8m();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this_0.m1(tmp1_safe_receiver);
      this_0.m1(' ');
    }
    this_0.m1(loggingEvent.s8m_1);
    this_0.m1(throwableToString(this, loggingEvent.t8m_1));
    return this_0.toString();
  }
}
class KLoggingEvent {
  constructor(level, marker, loggerName, message, cause, payload) {
    return new.target.w8m(level, marker, loggerName, message, cause, payload);
  }
  static w8m(level, marker, loggerName, message, cause, payload) {
    message = message === VOID ? null : message;
    cause = cause === VOID ? null : cause;
    payload = payload === VOID ? null : payload;
    var $this = createThis(this);
    $this.p8m_1 = level;
    $this.q8m_1 = marker;
    $this.r8m_1 = loggerName;
    $this.s8m_1 = message;
    $this.t8m_1 = cause;
    $this.u8m_1 = payload;
    return $this;
  }
  static x8m(level, marker, loggerName, eventBuilder) {
    return this.w8m(level, marker, loggerName, eventBuilder.r8l_1, eventBuilder.s8l_1, eventBuilder.t8l_1);
  }
  toString() {
    return 'KLoggingEvent(level=' + this.p8m_1.toString() + ', marker=' + toString(this.q8m_1) + ', loggerName=' + this.r8m_1 + ', message=' + this.s8m_1 + ', cause=' + toString(this.t8m_1) + ', payload=' + toString(this.u8m_1) + ')';
  }
  hashCode() {
    var result = this.p8m_1.hashCode();
    result = imul(result, 31) + (this.q8m_1 == null ? 0 : hashCode(this.q8m_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.r8m_1) | 0;
    result = imul(result, 31) + (this.s8m_1 == null ? 0 : getStringHashCode(this.s8m_1)) | 0;
    result = imul(result, 31) + (this.t8m_1 == null ? 0 : hashCode(this.t8m_1)) | 0;
    result = imul(result, 31) + (this.u8m_1 == null ? 0 : hashCode(this.u8m_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KLoggingEvent))
      return false;
    var tmp0_other_with_cast = other instanceof KLoggingEvent ? other : THROW_CCE();
    if (!this.p8m_1.equals(tmp0_other_with_cast.p8m_1))
      return false;
    if (!equals(this.q8m_1, tmp0_other_with_cast.q8m_1))
      return false;
    if (!(this.r8m_1 === tmp0_other_with_cast.r8m_1))
      return false;
    if (!(this.s8m_1 == tmp0_other_with_cast.s8m_1))
      return false;
    if (!equals(this.t8m_1, tmp0_other_with_cast.t8m_1))
      return false;
    if (!equals(this.u8m_1, tmp0_other_with_cast.u8m_1))
      return false;
    return true;
  }
}
class KLoggerDirect {
  constructor(name) {
    this.y8m_1 = name;
  }
  b8m(level, marker, block) {
    if (this.z8m(level, marker)) {
      // Inline function 'kotlin.apply' call
      var this_0 = new KLoggingEventBuilder();
      block(this_0);
      // Inline function 'kotlin.run' call
      if (level.w1_1 !== 5) {
        KotlinLoggingConfiguration_getInstance().m8m_1.j8m(KLoggingEvent.x8m(level, marker, this.y8m_1, this_0));
      }
    }
  }
  z8m(level, marker) {
    return isLoggingEnabled(level);
  }
}
class KLoggerFactory {
  c8m(name) {
    return new KLoggerDirect(name);
  }
}
class ConsoleOutputAppender extends FormattingAppender {
  i8m(loggingEvent, formattedMessage) {
    switch (loggingEvent.p8m_1.w1_1) {
      case 0:
        console.log(formattedMessage);
        break;
      case 1:
        console.log(formattedMessage);
        break;
      case 2:
        console.info(formattedMessage);
        break;
      case 3:
        console.warn(formattedMessage);
        break;
      case 4:
        console.error(formattedMessage);
        break;
      case 5:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
}
class KotlinLoggingConfiguration {
  constructor() {
    KotlinLoggingConfiguration_instance = this;
    this.k8m_1 = Level_INFO_getInstance();
    this.l8m_1 = new DefaultMessageFormatter(true);
    this.m8m_1 = new ConsoleOutputAppender();
  }
}
//endregion
function KLogger$debug$lambda($message) {
  return ($this$at) => {
    $this$at.r8l_1 = toStringSafe($message);
    return Unit_instance;
  };
}
function KLogger$warn$lambda($message) {
  return ($this$at) => {
    $this$at.r8l_1 = toStringSafe($message);
    return Unit_instance;
  };
}
function KLogger$error$lambda($message) {
  return ($this$at) => {
    $this$at.r8l_1 = toStringSafe($message);
    return Unit_instance;
  };
}
function KLogger$error$lambda_0($message, $throwable) {
  return ($this$at) => {
    $this$at.r8l_1 = toStringSafe($message);
    $this$at.s8l_1 = $throwable;
    return Unit_instance;
  };
}
var KotlinLogging_instance;
function KotlinLogging_getInstance() {
  return KotlinLogging_instance;
}
var Level_TRACE_instance;
var Level_DEBUG_instance;
var Level_INFO_instance;
var Level_WARN_instance;
var Level_ERROR_instance;
var Level_OFF_instance;
var Level_entriesInitialized;
function Level_initEntries() {
  if (Level_entriesInitialized)
    return Unit_instance;
  Level_entriesInitialized = true;
  Level_TRACE_instance = new Level('TRACE', 0, 0, 'TRACE');
  Level_DEBUG_instance = new Level('DEBUG', 1, 10, 'DEBUG');
  Level_INFO_instance = new Level('INFO', 2, 20, 'INFO');
  Level_WARN_instance = new Level('WARN', 3, 30, 'WARN');
  Level_ERROR_instance = new Level('ERROR', 4, 40, 'ERROR');
  Level_OFF_instance = new Level('OFF', 5, 50, 'OFF');
}
function Level_DEBUG_getInstance() {
  Level_initEntries();
  return Level_DEBUG_instance;
}
function Level_INFO_getInstance() {
  Level_initEntries();
  return Level_INFO_instance;
}
function Level_WARN_getInstance() {
  Level_initEntries();
  return Level_WARN_instance;
}
function Level_ERROR_getInstance() {
  Level_initEntries();
  return Level_ERROR_instance;
}
function toStringSafe(_this__u8e3s4) {
  var tmp;
  try {
    tmp = toString(_this__u8e3s4());
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Exception) {
      var e = $p;
      tmp_0 = DefaultErrorMessageProducer_instance.h8m(e);
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
var DefaultErrorMessageProducer_instance;
function DefaultErrorMessageProducer_getInstance() {
  return DefaultErrorMessageProducer_instance;
}
function prefix($this, level, loggerName) {
  var tmp;
  if ($this.o8m_1) {
    tmp = level.v1_1 + ': [' + loggerName + '] ';
  } else {
    tmp = '';
  }
  return tmp;
}
function throwableToString($this, $receiver) {
  return createThrowableMsg($this, '', $receiver);
}
function createThrowableMsg($this, msg, throwable) {
  var $this_0 = $this;
  var msg_0 = msg;
  var throwable_0 = throwable;
  $l$1: do {
    $l$0: do {
      var tmp;
      if (throwable_0 == null || equals(throwable_0.cause, throwable_0)) {
        tmp = msg_0;
      } else {
        var tmp0 = $this_0;
        var tmp1 = msg_0 + ", Caused by: '" + throwable_0.message + "'";
        var tmp2 = throwable_0.cause;
        $this_0 = tmp0;
        msg_0 = tmp1;
        throwable_0 = tmp2;
        continue $l$0;
      }
      return tmp;
    }
     while (false);
  }
   while (true);
}
function isLoggingEnabled(_this__u8e3s4) {
  return _this__u8e3s4.w1_1 >= KotlinLoggingConfiguration_getInstance().k8m_1.w1_1;
}
var KLoggerFactory_instance;
function KLoggerFactory_getInstance() {
  return KLoggerFactory_instance;
}
var KotlinLoggingConfiguration_instance;
function KotlinLoggingConfiguration_getInstance() {
  if (KotlinLoggingConfiguration_instance === VOID)
    new KotlinLoggingConfiguration();
  return KotlinLoggingConfiguration_instance;
}
//region block: post-declaration
initMetadataForInterface(KLogger, 'KLogger');
initMetadataForClass(KLoggingEventBuilder, 'KLoggingEventBuilder', KLoggingEventBuilder);
initMetadataForObject(KotlinLogging, 'KotlinLogging');
initMetadataForClass(Level, 'Level');
initMetadataForObject(DefaultErrorMessageProducer, 'DefaultErrorMessageProducer');
initMetadataForClass(FormattingAppender, 'FormattingAppender');
initMetadataForClass(DefaultMessageFormatter, 'DefaultMessageFormatter', DefaultMessageFormatter);
initMetadataForClass(KLoggingEvent, 'KLoggingEvent');
protoOf(KLoggerDirect).x8l = at$default;
protoOf(KLoggerDirect).w8l = debug;
protoOf(KLoggerDirect).y8l = warn;
protoOf(KLoggerDirect).z8l = error;
protoOf(KLoggerDirect).a8m = error_0;
initMetadataForClass(KLoggerDirect, 'KLoggerDirect', VOID, VOID, [KLogger]);
initMetadataForObject(KLoggerFactory, 'KLoggerFactory');
initMetadataForClass(ConsoleOutputAppender, 'ConsoleOutputAppender', ConsoleOutputAppender);
initMetadataForObject(KotlinLoggingConfiguration, 'KotlinLoggingConfiguration');
//endregion
//region block: init
KotlinLogging_instance = new KotlinLogging();
DefaultErrorMessageProducer_instance = new DefaultErrorMessageProducer();
KLoggerFactory_instance = new KLoggerFactory();
//endregion
//region block: exports
export {
  KotlinLogging_instance as KotlinLogging_instance3jisqrkz0n5up,
};
//endregion
